import { BackgroundColors, BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const NoteWrapper = styled.div``;

const NoteContainer = styled.form`
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	border: 1px solid ${BorderColors.Secondary};
	border-radius: ${BorderRadius.XL}px;
	padding: 24px;
`;

const DhcCommentContainer = styled.div`
	border-radius: ${BorderRadius.MD}px;
	border-top-left-radius: 0;
	background-color: ${BackgroundColors.PrimaryAlt};
	border: 1px solid ${BorderColors.Secondary};
	padding: 10px 14px;
	margin-bottom: 12px;
`;

const DhcInternalNote = styled.div<{ edit: boolean }>`
	border-radius: ${({ edit }) => (edit ? 8 : BorderRadius.MD)}px;
	border-top-left-radius: ${({ edit }) => (edit ? 8 : 0)}px;

	border: ${({ edit }) => (edit ? `2px dashed ${BorderColors.Secondary}` : `1px solid ${BorderColors.Secondary}`)};

	padding: 10px 14px;
	background-color: ${BackgroundColors.WarningPrimary};
	margin-bottom: 12px;
	position: relative;

	&:hover {
		#note-edit {
			display: block;
		}
	}
`;

const EditContainer = styled.div`
	position: absolute;
	right: 10px;
	bottom: -15px;
	display: none;
	box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03);
	height: 32px;
	width: 88px;
	background-color: rgba(22, 27, 38, 1);
	border: 1px solid rgba(51, 55, 65, 1);
	border-radius: ${BorderRadius.MD}px;

	&:hover {
		display: block;
	}
`;

const NotesWrapper = styled.div`
	margin-bottom: 32px;
`;

const StyledIcon = styled.div`
	cursor: pointer;

	&:hover {
		#copy,
		#trash {
			path {
				stroke: rgba(255, 255, 255, 1) !important;
			}
		}

		#small-pencil {
			path {
				fill: rgba(255, 255, 255, 1) !important;
			}
		}
	}
`;
export { NoteWrapper, NoteContainer, DhcCommentContainer, DhcInternalNote, StyledIcon, NotesWrapper, EditContainer };
